import './scss/App.scss';
import RouteRenderer from './routes/RouteRenderer';

function App() {
  return (
      <RouteRenderer/>
  );
}

export default App;
